import { BgColors } from "views/constants/enums/bgColors";
import "./style.scss";

type LabelProps = {
  content?: string;
  backgroundColor: BgColors;
};

export const Label: React.FC<LabelProps> = ({ content, backgroundColor }) => {
  return <div className={`label ${backgroundColor}`}>{content}</div>;
};
